<template>

  <div class="add-user-site-page">
    <section class="add-hero">
      <div class="add-hero__left">
        <div class="add-hero__icon">
          <feather-icon
            icon="Edit3Icon"
            size="18"
            class="text-white"
          />
        </div>
        <div class="ml-1">
          <h2 class="add-hero__title mb-0">
            Edit User
          </h2>
          <p class="add-hero__subtitle mb-0">
            Update any section and save changes at any step — no need to reach the end.
          </p>
        </div>
      </div>

      <div class="add-hero__right">
        <div class="stepper">
          <div
            class="stepper__item"
            :class="{
              'stepper__item--active': currentStep === 1,
              'stepper__item--done': currentStep > 1
            }"
            @click="goToStep(1)"
          >
            <div class="stepper__dot">
              1
            </div>
            <div class="stepper__text">
              Profile
            </div>
          </div>
          <div
            class="stepper__item"
            :class="{
              'stepper__item--active': currentStep === 2,
              'stepper__item--done': currentStep > 2
            }"
            @click="goToStep(2)"
          >
            <div class="stepper__dot">
              2
            </div>
            <div class="stepper__text">
              Employment
            </div>
          </div>
          <div
            class="stepper__item"
            :class="{
              'stepper__item--active': currentStep === 3,
              'stepper__item--done': currentStep > 3
            }"
            @click="goToStep(3)"
          >
            <div class="stepper__dot">
              3
            </div>
            <div class="stepper__text">
              Documents
            </div>
          </div>
          <div
            class="stepper__item"
            :class="{
              'stepper__item--active': currentStep === 4
            }"
            @click="goToStep(4)"
          >
            <div class="stepper__dot">
              4
            </div>
            <div class="stepper__text">
              Payroll & Leave
            </div>
          </div>
        </div>
      </div>
    </section>

    <b-alert
      v-if="!$route.params.id"
      show
      variant="warning"
      class="mt-1"
    >
      This page is <strong>Edit-only</strong>. Please open a user from the list to edit details.
    </b-alert>

    <b-card
      v-else
      class="add-shell"
    >
      <b-row
        v-show="currentStep === 1"
        class="add-form"
      >
        <b-col
          cols="12"
        >
          <div class="section-title">
            <feather-icon
              icon="UserIcon"
              size="16"
              class="mr-50 text-primary"
            />
            Profile information
          </div>
        </b-col>
        <b-col md="6">
          <b-form-group
            label="Name"
            label-for="name"
          >
            <b-form-input
              id="name"
              v-model="userSiteForm.name"
              trim
              placeholder="Name"
            />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            label="Email"
            label-for="email"
          >
            <b-form-input
              id="email"
              v-model="userSiteForm.email"
              type="email"
              trim
              placeholder="Email"
            />

          </b-form-group>
        </b-col>

        <b-col
          v-if="passwordRequired"
          md="6"
        >
          <b-form-group
            label="Password"
            label-for="password"
          >
            <b-form-input
              id="password"
              v-model="userSiteForm.password"
              type="password"
              trim
              placeholder="Password"
            />

          </b-form-group>
        </b-col>
        <b-col
          v-if="passwordRequired"
          md="6"
        >
          <b-form-group
            label="Password Confirmation"
            label-for="password_confirmation"
          >
            <b-form-input
              id="password_confirmation"
              v-model="userSiteForm.password_confirmation"
              type="password"
              trim
              placeholder="Password Confirmation"
            />
          </b-form-group>
        </b-col>

        <b-col
          v-if="isActivation"
          md="6"
        >
          <b-form-group
            label="Activation "
            label-for="Activation"
          >
            <b-form-select
              id="office_id"
              v-model="userSiteForm.active"
              :options="optionsActive"
              trim
              placeholder="Is Active"
            />
          </b-form-group>
        </b-col>

        <b-col
          md="6"
        >
          <b-form-group
            label="office "
            label-for="office"
          >
            <b-form-select
              id="office_id"
              v-model="userSiteForm.office_id"
              :options="optionsOffice"
              trim
              placeholder="Office"
            />

          </b-form-group>
        </b-col>

        <b-col md="6">
          <b-form-group
            label="role "
            label-for="role"
          >
            <b-form-select
              id="role"
              v-model="userSiteForm.role"
              :options="optionsRoles"
              trim
              placeholder="role"
            />
          </b-form-group>
        </b-col>

        <b-col
          md="6"
        >
          <b-form-group
            label="Nationality "
            label-for="Nationality"
          >
            <v-select
              id="nationality"
              v-model="userSiteForm.nationality"
              :options="optionsNationality"
              trim
              placeholder="choose your nationality"
              label="text"
              :searchable="true"
              :clearable="false"
            />
          </b-form-group>
        </b-col>

      </b-row>

      <b-row
        v-show="currentStep === 2"
        class="add-form"
      >
        <b-col
          cols="12"
        >
          <div class="section-title mt-1">
            <feather-icon
              icon="BriefcaseIcon"
              size="16"
              class="mr-50 text-primary"
            />
            Employment details
          </div>
        </b-col>

        <!-- required for engineer  -->
        <b-col
          v-if="isNotesSelected"
          md="6"
        >
          <b-form-group
            label="Joined At "
            label-for="Joined At"
          >
            <b-form-input
              id="joined_at"
              v-model="userSiteForm.joined_at"
              trim
              type="date"
              placeholder="Joined At"
            />
          </b-form-group>
        </b-col>

        <b-col
          v-if="isNotesSelected"
          md="6"
        >
          <b-form-group
            label="Department "
            label-for="Department"
          >
            <b-form-select
              id="office_id"
              v-model="userSiteForm.department_id"
              :options="optionsDepertment"
              trim
              placeholder="Department"
            />

          </b-form-group>
        </b-col>

        <b-col
          md="6"
        >
          <b-form-group
            label="Supervisor "
            label-for="Supervisor"
          >
            <v-select
              id="supervisor_id"
              v-model="userSiteForm.supervisor_id"
              :options="optionsSupervisor"
              :reduce="option => option.value.id"
              multiple
              trim
              placeholder="Supervisor"
              value="id"
            />
          </b-form-group>
        </b-col>

        <b-col
          md="6"
        >
          <b-form-group
            label="Is Internal Employee "
            label-for="Is Internal Employee"
          >
            <b-form-select
              id="is_internal_employee"
              v-model="userSiteForm.is_internal_employee"
              :options="[{ value: 1, text: 'Yes' }, { value: 0, text: 'No' }]"
              trim
              placeholder="Is Internal Employee"
            />
          </b-form-group>
        </b-col>

        <b-col
          v-if="isNotesSelected"
          md="12"
        >
          <b-form-group
            label="Job Description "
            label-for="Job Description"
          >
            <b-form-input
              id="job_description"
              v-model="userSiteForm.job_description"
              trim
              placeholder="Job Description"
            />
          </b-form-group>
        </b-col>

      </b-row>

      <b-row
        v-show="currentStep === 3"
        class="add-form"
      >
        <b-col
          cols="12"
        >
          <div class="section-title mt-1">
            <feather-icon
              icon="FileTextIcon"
              size="16"
              class="mr-50 text-primary"
            />
            Documents & IDs
          </div>
        </b-col>

        <b-col md="6">
          <b-form-group
            label="labour card expiry date"
            label-for="labour card expiry date"
          >
            <b-form-datepicker
              v-model="userSiteForm.labour_card_expiry_date"
            />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            label="labour card issue date"
            label-for="labour card issue date"
          >
            <b-form-datepicker
              v-model="userSiteForm.labour_card_issue_date"
            />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            label="passport expiry date"
            label-for="passport expiry date"
          >
            <b-form-datepicker
              v-model="userSiteForm.passport_expiry_date"
            />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            label="passport issue date"
            label-for="passport issue date"
          >
            <b-form-datepicker
              v-model="userSiteForm.passport_issue_date"
            />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            label="passport number"
            label-for="passport number"
          >
            <b-form-input
              v-model="userSiteForm.passport_number"
            />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            label="visa expiry date"
            label-for="visa expiry date"
          >
            <b-form-datepicker
              v-model="userSiteForm.visa_expiry_date"
            />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            label="visa issue date"
            label-for="visa issue date"
          >
            <b-form-datepicker
              v-model="userSiteForm.visa_issue_date"
            />
          </b-form-group>
        </b-col>
        <b-col md="6" />

      </b-row>

      <b-row
        v-show="currentStep === 4"
        class="add-form"
      >
        <b-col
          cols="12"
        >
          <div class="section-title mt-1">
            <feather-icon
              icon="DollarSignIcon"
              size="16"
              class="mr-50 text-primary"
            />
            Payroll & attachments
          </div>
        </b-col>

        <b-col md="6">
          <b-form-group
            label="pension"
            label-for="pension"
          >
            <b-form-input
              id="pension"
              v-model="userSiteForm.pension"
              type="number"
              trim
              placeholder="pension"
            />
          </b-form-group>
        </b-col>

        <b-col md="6">
          <b-form-group
            label="pension months"
            label-for="pension months"
          >
            <b-form-input
              id="pension_months"
              v-model="userSiteForm.pension_months"
              type="number"
              trim
              placeholder="pension months"
            />
          </b-form-group>
        </b-col>

        <b-col md="6">
          <b-form-group
            label="mode of payment"
            label-for="mode of payment"
          >
            <b-form-input
              id="mode_of_payment"
              v-model="userSiteForm.mode_of_payment"
              trim
              placeholder="mode of payment"
            />
          </b-form-group>
        </b-col>

        <b-col md="6">
          <b-form-group
            label="certificate files"
            label-for="certificate files"
          >
            <b-form-file
              v-model="userSiteForm.employee_certificate_files"
              trim
              multiple
              placeholder="certificate files"
            />
          </b-form-group>
          <b-list-group>
            <b-list-group-item
              v-for=" file in userSiteForm.employee_certificate_files"
              :key="file.id"
            >
              <feather-icon
                icon="FileIcon"
                class="mr-1"
              />
              <a
                target="_blank"
                :href="file.url"
              >{{ file.name }}</a>
            </b-list-group-item>
          </b-list-group>
        </b-col>

        <b-col md="6">
          <b-form-group
            label="contract files"
            label-for="contract files"
          >
            <b-form-file
              v-model="userSiteForm.employee_contract_files"
              trim
              multiple
              placeholder="contract files"
            />
          </b-form-group>
          <b-list-group>
            <b-list-group-item
              v-for=" file in userSiteForm.employee_contract_files"
              :key="file.id"
            >
              <feather-icon
                icon="FileIcon"
                class="mr-1"
              />
              <a
                target="_blank"
                :href="file.url"
              >{{ file.name }}</a>
            </b-list-group-item>
          </b-list-group>
        </b-col>

        <b-col md="6">
          <b-form-group
            label="contract start date "
            label-for="contract start date"
          >
            <b-form-input
              id="contract_start_date"
              v-model="userSiteForm.contract_start_date"
              trim
              type="date"
              placeholder="contract start date"
            />
          </b-form-group>
        </b-col>

        <b-col md="6">
          <b-form-group
            label="contract end date "
            label-for="contract end date"
          >
            <b-form-input
              id="contract_end_date"
              v-model="userSiteForm.contract_end_date"
              trim
              type="date"
              placeholder="contract end date"
            />
          </b-form-group>
        </b-col>

        <b-col md="6">
          <b-form-group
            label="additional files"
            label-for="additional files"
          >
            <b-form-file
              v-model="newAdditionalFiles"
              trim
              multiple
              placeholder="additional files"
            />
          </b-form-group>
          <b-list-group>
            <b-list-group-item
              v-for="file in existingAdditionalFiles"
              :key="file.id"
              class="d-flex align-items-center justify-content-between"
            >
              <div class="d-flex align-items-center min-w-0">
                <feather-icon
                  icon="FileIcon"
                  class="mr-1 flex-shrink-0"
                />
                <a
                  target="_blank"
                  :href="file.url"
                  class="text-truncate"
                >{{ file.name }}</a>
              </div>
              <button
                type="button"
                class="btn btn-sm btn-outline-danger ml-1 flex-shrink-0"
                :disabled="deletingFileId === file.id"
                title="Delete file"
                @click="deleteAdditionalFile(file)"
              >
                <b-spinner
                  v-if="deletingFileId === file.id"
                  small
                />
                <feather-icon
                  v-else
                  icon="Trash2Icon"
                  size="14"
                />
              </button>
            </b-list-group-item>
          </b-list-group>
        </b-col>

        <b-col
          cols="12"
        >
          <div class="section-title mt-1">
            <feather-icon
              icon="ClipboardIcon"
              size="16"
              class="mr-50 text-primary"
            />
            Leave balances
          </div>
        </b-col>

        <b-col
          cols="12"
          md="12"
        >
          <!-- Name -->
          <validation-provider
            #default="validationContext"
            name="Defult Leaves Balance"
            rules="required"
          >
            <b-form-group
              label="Defult Leaves Balance"
              label-for="Defult Leaves Balance"
            >
              <div class="leave-matrix leave-matrix--default">
                <div class="table-responsive">
                  <table class="table table-sm table-bordered mb-0">
                    <thead>
                      <tr>
                        <th
                          v-for="(item, index) in defaultLeaveBalance"
                          :key="`default-type-${index}`"
                          class="text-center"
                        >
                          {{ item.type }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td
                          v-for="(item, index) in defaultLeaveBalance"
                          :key="`default-balance-${index}`"
                          class="p-0"
                        >
                          <b-form-input
                            :id="`default-leave-${index}`"
                            v-model="item.balance"
                            type="number"
                            disabled
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

        </b-col>

        <b-col
          cols="12"
          md="12"
          class="mt-1"
        >
          <!-- Name -->
          <validation-provider
            #default="validationContext"
            name="Leaves Balance"
            rules="required"
          >
            <b-form-group
              label="Leaves Balance"
              label-for="Leaves Balance"
            >
              <div class="leave-matrix leave-matrix--editable">
                <div class="table-responsive">
                  <table class="table table-sm table-bordered mb-0">
                    <thead>
                      <tr>
                        <th
                          v-for="(item, index) in userSiteForm.leaves_balance"
                          :key="`leave-type-${index}`"
                          class="text-center"
                        >
                          {{ item.type }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td
                          v-for="(item, index) in userSiteForm.leaves_balance"
                          :key="`leave-balance-${index}`"
                          class="p-0"
                        >
                          <b-form-input
                            :id="`leave-${item.id || index}`"
                            v-model="item.balance"
                            type="number"
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

        </b-col>

        <!-- Server Errors -->
        <b-col
          v-if="Object.values(errors).length > 0"
          cols="12"
        >
          <p
            v-for="(error, key, index) in errors"
            :key="index"
            class="text-danger small"
          >
            {{ error.toString() }}
          </p>
        </b-col>

      </b-row>
      <b-row>
        <b-col
          cols="12"
          class="mt-50"
        >

          <div class="actions-bar">
            <div class="actions-bar__left">
              <b-button
                variant="outline-secondary"
                class="action-secondary"
                :disabled="currentStep === 1 || loader"
                @click="prevStep"
              >
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="16"
                  class="mr-50"
                />
                Back
              </b-button>
              <span class="actions-bar__hint">
                Step {{ currentStep }} of 4
              </span>
            </div>

            <div class="actions-bar__right">
              <b-button
                v-if="!loader"
                variant="primary"
                class="action-primary action-save"
                @click="addUserSite()"
              >
                <span class="action-save__icon">
                  <feather-icon
                    icon="SaveIcon"
                    size="15"
                  />
                </span>
                Save Changes
              </b-button>
              <b-button
                v-else
                variant="primary"
                disabled
                class="action-primary action-save"
              >
                <b-spinner
                  small
                  type="grow"
                  class="mr-50"
                />
                Saving...
              </b-button>

              <b-button
                v-if="currentStep < 4"
                variant="dark"
                class="action-dark"
                :disabled="loader"
                @click="nextStep"
              >
                Next
                <feather-icon
                  icon="ChevronRightIcon"
                  size="16"
                  class="ml-50"
                />
              </b-button>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-card>
  </div>

</template>

<script>
import { ref } from '@vue/composition-api'
import formValidation from '@core/comp-functions/forms/form-validation'
import axios from 'axios'
import { required } from '@validations'
import VSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
// eslint-disable-next-line no-unused-vars
import _ from 'lodash'
import decryptData from '@/store/auth/decryptData'
import nationals from '../../../global-compositions/Nationality'

export default {
  components: {
    'v-select': VSelect,
  },
  data() {
    return {
      id: this.$store.state.generalIds.id,
      required,
      userNameBreadcrumb: '',
      allSelected: [],
      users: [],
      loader: false,
      validationErrors: {},
      passwordRequired: true,
      isActivation: false,
      errors: {},
      defaultLeaveBalance: [],
      currentStep: 1,
      newAdditionalFiles: [],
      deletingFileId: null,
      optionsActive: [
        {
          value: '0',
          text: 'Not Active',
        },
        {
          value: '1',
          text: 'Active',
        },
      ],

    }
  },

  setup() {
    const { getValidationState } = formValidation()
    // eslint-disable-next-line camelcase
    const userSiteForm = ref({
      name: '',
      email: '',
      role: '',
      nationality: '',
      department_id: [],
      joined_at: '',
      job_description: '',
      office_id: [],
      active: [],
      status_id: [],
      supervisor_id: [],
      leaves_balance: [],
      pension: '',
      pension_months: '',
      mode_of_payment: '',
      is_internal_employee: null,
      labour_card_expiry_date: null,
      labour_card_issue_date: null,
      passport_expiry_date: null,
      passport_issue_date: null,
      passport_number: null,
      visa_expiry_date: null,
      visa_issue_date: null,
      contract_start_date: null,
      contract_end_date: null,
      additional_files: [],
    })
    return {
      getValidationState,
      userSiteForm,
    }
  },
  computed: {
    existingAdditionalFiles() {
      const files = this.userSiteForm.additional_files
      if (!Array.isArray(files)) return []
      return files.filter(file => file && file.id)
    },
    isNotesSelected() {
      return this.userSiteForm.role === 'engineer'
    },
    optionsOffice() {
      return this.$store.getters['generalData/offices/offices'].filter(item => item.value !== null)
    },
    optionsRoles() {
      return this.$store.getters['generalData/roles/roles'].filter(item => item.value !== null)
    },
    optionsDepertment() {
      return this.$store.getters['generalData/departments/departments']
    },
    optionsSupervisor() {
      return this.$store.getters['generalData/assignList/assignList']
    },
    optionsNationality() {
      return nationals
    },
  },
  async mounted() {
    if (this.$route.params.id) {
      this.passwordRequired = false
      this.isActivation = true
    }
    this.showUserSite()

    if (!this.$store.getters['generalData/offices/officesLoaded']) {
      this.loadtable = true
      await this.$store.dispatch('generalData/offices/fetchOffices')
      this.loadtable = false
    }
    if (!this.$store.getters['generalData/roles/roleLoaded']) {
      this.loadtable = true
      await this.$store.dispatch('generalData/roles/fetchRoles')
      this.loadtable = false
    }
    if (!this.$store.getters['generalData/departments/departmentsLoaded']) {
      this.loadtable = true
      await this.$store.dispatch('generalData/departments/fetchDepartments')
      this.loadtable = false
    }
    if (!this.$store.getters['generalData/assignList/assignListLoaded']) {
      this.loadtable = true
      await this.$store.dispatch('generalData/assignList/fetchAssignList')
      this.loadtable = false
    }
  },
  methods: {
    nextStep() {
      if (this.currentStep < 4) this.currentStep += 1
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    prevStep() {
      if (this.currentStep > 1) this.currentStep -= 1
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    goToStep(step) {
      const s = Number(step)
      if (Number.isNaN(s)) return
      if (s < 1 || s > 4) return
      this.currentStep = s
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    showUserSite() {
      if (this.$route.params.id) {
        axios.get(`/register/site/user/${this.$route.params.id}`).then(res => {
          const userData = decryptData(res.data.payload).data.user
          // console.log(userData)
          this.userSiteForm.name = userData.name
          this.userSiteForm.email = userData.email
          this.userSiteForm.role = userData.role
          this.userSiteForm.nationality = userData.nationality
          this.userSiteForm.department_id = userData.department_id
          this.userSiteForm.joined_at = userData.joined_at
          this.userSiteForm.job_description = userData.job_description
          this.userSiteForm.office_id = userData.office_id
          this.userSiteForm.active = userData.active
          this.userSiteForm.status_id = Array.isArray(userData.status)
            ? userData.status.map(item => item.id)
            : []

          this.userSiteForm.supervisor_id = Array.isArray(userData.supervisor_id)
            ? userData.supervisor_id.map(id => Number(id))
            : []
          this.userSiteForm.is_internal_employee = Number(userData.is_internal_employee)

          this.userSiteForm.pension = userData.pension
          this.userSiteForm.pension_months = userData.pension_months
          this.userSiteForm.mode_of_payment = userData.mode_of_payment

          this.userSiteForm.labour_card_expiry_date = userData.labour_card_expiry_date
          this.userSiteForm.labour_card_issue_date = userData.labour_card_issue_date
          this.userSiteForm.passport_expiry_date = userData.passport_expiry_date
          this.userSiteForm.passport_issue_date = userData.passport_issue_date
          this.userSiteForm.passport_number = userData.passport_number
          this.userSiteForm.visa_expiry_date = userData.visa_expiry_date
          this.userSiteForm.visa_issue_date = userData.visa_issue_date

          this.userSiteForm.employee_certificate_files = userData.employee_certificate_files
          this.userSiteForm.employee_contract_files = userData.employee_contract_files
          this.userSiteForm.contract_start_date = userData.contract_start_date
          this.userSiteForm.contract_end_date = userData.contract_end_date
          this.userSiteForm.additional_files = Array.isArray(userData.additional_files)
            ? userData.additional_files
            : []
          this.newAdditionalFiles = []

          this.userSiteForm.leaves_balance = userData.current_leave_balance
          this.defaultLeaveBalance = userData.default_leave_balance
        })
      } else {
        return false
      }
      return true
    },

    deleteAdditionalFile(file) {
      if (!file?.id || !this.$route.params.id) return

      this.$swal({
        title: 'Delete this file?',
        text: file.name || 'This file will be removed permanently.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#dc2626',
        cancelButtonColor: '#6e6b7b',
        confirmButtonText: 'Yes, delete it',
      }).then(result => {
        if (!result.isConfirmed) return

        this.deletingFileId = file.id
        axios
          .delete(`register/site/user/${this.$route.params.id}/additional-files/${file.id}`)
          .then(() => {
            this.userSiteForm.additional_files = (this.userSiteForm.additional_files || [])
              .filter(item => item.id !== file.id)
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'File deleted successfully',
                icon: 'CheckIcon',
                variant: 'success',
              },
            })
          })
          .catch(error => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: error.response?.data?.message || 'Failed to delete file',
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            })
          })
          .finally(() => {
            this.deletingFileId = null
          })
      })
    },

    addUserSite() {
      if (this.$route.params.id) {
        this.loader = true
        const formData = new FormData()
        formData.append('_method', 'PUT')
        Object.keys(this.userSiteForm).forEach(key => {
          let value = this.userSiteForm[key]

          // Convert null to string "null" explicitly
          if (value === null) {
            value = ''
          }

          if (Array.isArray(value)) {
            if (key === 'supervisor_id') {
              value.forEach((sup, i) => {
                formData.append(`supervisor_id[${i}]`, sup)
              })
            } else if (key === 'leaves_balance') {
              value.forEach((item, i) => {
                formData.append(`leaves_balance[${i}][type]`, item.type)
                formData.append(`leaves_balance[${i}][balance]`, item.balance)
              })
            } else if (key === 'additional_files') {
              // Existing media stays on the server; only new File uploads are sent.
            } else {
              value.forEach((item, i) => {
                if (item instanceof File) {
                  formData.append(`${key}[${i}]`, item)
                }
              })
            }
          } else {
            formData.append(key, value)
          }
        })

        let uploads = []
        if (Array.isArray(this.newAdditionalFiles)) {
          uploads = this.newAdditionalFiles
        } else if (this.newAdditionalFiles) {
          uploads = [this.newAdditionalFiles]
        }
        uploads.forEach((item, i) => {
          if (item instanceof File) {
            formData.append(`additional_files[${i}]`, item)
          }
        })

        axios.post(`register/site/user/${this.$route.params.id}`, formData).then(res => {
          if (res.status === 200) {
            this.newAdditionalFiles = []
            this.showUserSite()
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Changes saved successfully',
                icon: 'CheckIcon',
                variant: 'success',
              },
            })
          }
        }).catch(error => {
          if (error.response.status) {
            const payload = decryptData(error.response.data.payload).message
            const firstArrayKey = Object.keys(payload).find(key => Array.isArray(payload[key]))
            const errorMessage = firstArrayKey ? payload[firstArrayKey][0] : 'An unknown error occurred'
            this.$toast({
              component: ToastificationContent,
              props: {
                title: errorMessage,
                icon: 'BellIcon',
                variant: 'error',
              },
            })
          }
        }).finally(() => {
          this.loader = false
        })
      }
    },
  },

}
</script>

  <style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
  </style>

  <style lang="scss" src="@/assets/scss/pages/user-site/add-user-site.scss"></style>
